import React, { Component } from "react";
import { Spinner } from "@veriff/genoma";

import "./UploadStatus.css";

class UploadStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hovering: false,
            isOpen: false,
        };
        this.setHover = this.setHover.bind(this);
        this.clearHover = this.clearHover.bind(this);
    }

    setHover() {
        this.setState({ hovering: true });
    }
    clearHover() {
        this.setState({ hovering: false });
    }

    render() {
        if (this.props.type === "folder") {
            if (this.props.status === "error") {
                return <img className="folder-upload-status" alt="error" src="/icon-alert.svg" />;
            } else if (this.props.status === "pending") {
                return <Spinner className="folder-upload-status" />;
            } else if (this.props.status === "success") {
                return <img className="folder-upload-status" alt="done" src="/icon-green-check-mark.svg" />;
            } else return null;
        } else if (this.props.type === "file") {
            if (this.props.info && !this.props.info.isOk) {
                return (
                    <div className="upload-error" onMouseEnter={this.setHover} onMouseLeave={this.clearHover}>
                        {this.state.hovering ? (
                            <div className="error-form">
                                <h5>Error</h5> {this.props.info.data}
                            </div>
                        ) : null}
                        <img alt="error" src="/icon-alert.svg" />
                    </div>
                );
            } else if (this.props.uploadStarted || this.props.uploadFlowOk) {
                return (
                    <div className="upload-error">
                        {this.props.progress && this.props.progress.state === "done" ? (
                            <img alt="done" src="/icon-green-check-mark.svg" />
                        ) : (
                            <Spinner />
                        )}
                    </div>
                );
            } else {
                return null;
            }
        } else if (this.props.type === "lightFile") {
            return (
                <div className="upload-error" onMouseEnter={this.setHover} onMouseLeave={this.clearHover}>
                    {this.state.hovering ? (
                        <div className="error-form">
                            <h5>Error</h5> {this.props.info}
                        </div>
                    ) : null}
                    <img alt="error" src="/icon-alert.svg" />
                </div>
            );
        }
    }
}

export default UploadStatus;
